import { graphql } from "@/gql";

export const departingBookingsQuery = graphql(`
  query DashboardDepartingBookings($supplierId: ID, $now: Mixed) {
    bookings(
      page: 1
      first: 10
      supplier_id: $supplierId
      status: [CONFIRMED]
      where: { column: DEPART_AT, operator: GTE, value: $now }
      orderBy: [{ column: DEPART_AT, order: ASC }]
    ) {
      data {
        id
        reference
        name
        depart_at
        supplier {
          timezone
        }
        departureOffice {
          id
          name
        }
        deliveryOffice {
          id
          name
        }
        vehicle {
          id
          name
        }
      }
    }
  }
`);
